import { generateCurrentDistance } from 'modules/racersTable/derivations';

import { filtersStore, distancesStore } from '../stores';

const currentDistance = generateCurrentDistance(filtersStore, distancesStore);

export { currentDistance };
